const flattenForm = (array) => array.flatMap((row) => row)
  .flatMap((row) => (row.grouped ? row.rows : row));

export default flattenForm;
